export default "__VITE_ASSET__1cAnoUfu__"